import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'mar-page-bar',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<section class="w-section max-w-8xl m-auto">
			<ng-content />
		</section>
	`,
	host: {
		class: 'w-full bg-primary-900 py-4 block z-[101] transition-shadow duration-1000',
	},
})
export class PageBarComponent {}
